import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

// Initial state
const initialState = {
  filters: {
    modalFiltersRules: undefined,
    modalConditions: undefined,
  },
};
// Actual Slice
export const myIssuesMailboxSlice = createSlice({
  name: 'myIssuesMailbox',
  initialState,
  reducers: {
    filtersModalConditionMyIssuesMailboxChangeSuccess: (state, { payload }) => {
      state.filters.modalConditions = payload;
      if (!payload?.rules?.length) {
        state.filters.modalFiltersRules = undefined;
      }
    },
    filtersModalRulesMyIssuesMailboxChangeSuccess: (state, { payload }) => {
      state.filters.modalFiltersRules = payload;
    },
    resetModalMyIssuesMailboxChangeSuccess: (state) => {
      state.filters.modalConditions = null;
      state.filters.modalFiltersRules = null;
    },
  },
  // Special reducer for hydrating the state. Special case for next-redux-wrapper
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.myIssuesMailbox,
      };
    },
  },
});

export const {
  filtersModalConditionMyIssuesMailboxChangeSuccess,
  filtersModalRulesMyIssuesMailboxChangeSuccess,
  resetModalMyIssuesMailboxChangeSuccess,
} = myIssuesMailboxSlice.actions;

export const selectMyIssuesMailboxState = (state) => state.myIssuesMailbox;

export default myIssuesMailboxSlice.reducer;

export const filtersModalConditionMyIssuesMailboxChange = (conditions) => {
  return (dispatch) => {
    dispatch(filtersModalConditionMyIssuesMailboxChangeSuccess(conditions));
  };
};
export const filtersModalRulesMyIssuesMailboxChange = (rules) => {
  return (dispatch) => {
    dispatch(filtersModalRulesMyIssuesMailboxChangeSuccess(rules));
  };
};
export const resetModalMyIssuesMailboxChange = () => {
  return (dispatch) => {
    dispatch(resetModalMyIssuesMailboxChangeSuccess());
  };
};
